import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import Helper from "../../Helper";

interface CommandErrorProps {
    image?: string;
    error: any;
}

const CommandError: React.FC<CommandErrorProps> = ({ image, error }) => {
    return (
        <div
            className={Helper.classNames(
                "absolute top-0 left-0 right-0 bg-neutral-900 border-b border-neutral-700 z-1200 w-screen transition-all duration-700 ease-in-out flex items-center justify-center overflow-hidden h-screen"
            )}
        >
            <div style={{ zIndex: -1 }} className="absolute inset-0 flowing-gradient opacity-40" />
            <div className="relative w-2/3 h-auto flex flex-col items-center justify-center">
                <img
                    src={image ?? "/img/png/logo/plot_jobsite_command.png"}
                    alt="PLOT Logo"
                    className="w-full max-w-2/3 h-auto object-contain opacity-75 z-10"
                    style={{ opacity: 0.75, pointerEvents: "auto" }}
                />
                <div className="flex flex-col gap-2 items-center mt-4">
                    <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-500 text-6xl" />
                    <h2 className="text-4xl font-semibold text-plot-white/75 dark:text-plot-slate">
                        Error Loading Jobsite Command
                    </h2>
                    <p className="text-2xl text-plot-white/50 dark:text-plot-white mt-2">
                        {error?.message || "An unknown error occurred."}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CommandError;
